import styled from 'styled-components';
import { H2, Input, Label, PanelBody } from '@studio/legacy-components';

export const PriorityPanelBody = styled(PanelBody)`
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25em;
  ${H2} {
    display: inline;
  }
`;

export const InputContainer = styled.div`
  ${Label} {
    font-weight: var(--bold);
  }
  ${Input} {
    -moz-appearance: textfield;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    width: 217px;
  }
`;

export const ContainerTable = styled.table`
  display: grid;
  border: 1px solid var(--sharkbait-ooh-la-la);
  border-radius: 6px;
  padding: 0.5em 1em;
  max-width: 700px;
  height: 120px;
`;

export const Body = styled.tbody`
  overflow-y: scroll;
`;

export const Priority = styled.td`
  padding-right: 6px;
`;

export const Details = styled.td``;

export const FlowInformation = styled.div`
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 550px;
  margin-right: 6px;
`;

export const Name = styled.span``;

export const PageTargeting = styled.span`
  color: var(--text-secondary);

  :before {
    content: '|';
    margin: 0 4px;
  }
`;

export const Row = styled.tr`
  line-height: 2em;
  color: var(--heading-primary);
  font-weight: var(--normal);

  ${props => props.$emphasized && `font-weight: var(--bold);`}

  ${Priority}, ${Name} {
    ${props => props.$emphasized && `color: var(--text-primary);`}
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const PreviewLabelText = styled.span`
  font-weight: var(--bold);
  color: var(--heading-primary);
`;
